<template>
  <div style="height: 100%">
    <div id="grid-wrappers" style="width: 100%; height: 100%">
      <ag-grid-vue
        style="width: 100%; height: 600px;"
        class="ag-theme-alpine "
        :columnDefs="columnDefs"
        :autoGroupColumnDef="autoGroupColumnDef"
        :defaultColDef="defaultColDef"
        :rowSelection="rowSelection"
        :rowGroupPanelShow="rowGroupPanelShow"
        :pivotPanelShow="pivotPanelShow"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :paginationNumberFormatter="paginationNumberFormatter"
        :rowData="rowData"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import SpanServiceNo from "@/components/prospectservice/SpanServiceNoMobilePhone.vue";
import ButtonPage from "@/components/prospectservice/ButtonPage.vue";

import http from "@/services/AuthService";
import LoadingBs5 from "@/components/frontend/LoadingBs5";

export default {
  name: "HistoryMoblie",
  components: {
    SpanServiceNo,
    ButtonPage,
    LoadingBs5
  },
  data() {
    return {
      columnDefs: [
        { headerName: "เลขที่รับงานบริการ", field: "REQUEST_NO", cellRenderer: 'SpanServiceNo', flex: 1, lockPosition: 'left', width: 180, maxWidth: 180 },
        { headerName: "รายการที่ขอแก้ไข", field: "JOB_DESC" , flex: 1 , lockPosition: 'left', },
        { lockPosition: 'right', cellRenderer: 'ButtonPage', colId: 'params', width: 50, maxWidth: 50 },
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        flex: 1,
        minWidth: 100,
        wrapText: true, 
        autoHeight: true,
        cellClass: 'locked-col',
        filter: true,
      },
      autoGroupColumnDef: null,
      rowSelection: null,
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      rowData: [],
      Loading: true,
    };
  },
  setup() {
    return {};
  },
  mounted() {
    if(this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }
    
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetHistoryProspect?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200){
        if(res.data.length > 0) {
          res.data.forEach(item => {
            this.rowData.push(item);
          });
          this.Loading = false;
        }
        else {
          this.rowData = [];
          this.Loading = false;
        }
      }
    });
  },
  created() {
    this.autoGroupColumnDef = {
      headerName: 'Group',
      minWidth: 170,
      field: 'athlete',
      valueGetter: (params) => {
        if (params.node.group) {
          return params.node.key;
        } else {
          return params.data[params.colDef.field];
        }
      },
    };
    this.rowSelection = 'multiple';
    this.rowGroupPanelShow = 'always';
    this.pivotPanelShow = 'always';
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = (params) => {
      return '[' + params.value.toLocaleString() + ']';
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.paginationGoToPage(0);
    },
    onPageSizeChanged() {
      var value = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
  },
};
</script>

<style scoped>
.ag-theme-alpine {
  --ag-font-size: 23px;
  --ag-font-family: "DB Heavent";
}
</style>